import styled from 'styled-components'

import { BuyPremiumIcon } from '@root/entities/premium/ui'
import { useTranslation } from '@root/shared/localization'

const RATIO_BOOSER_ICON = 0.3
const RATIO_BOOSER_ICON_2 = 0.22
const SIZE = 91

export const PremiumScreenHeading: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Root>
      <Title>{t('common.d-premium')}</Title>
      <BuyPremiumIconAlt product="subscription" size={SIZE} />
      <BoosterIcon1 product="boosters" size={SIZE * RATIO_BOOSER_ICON} />
      <BoosterIcon2 product="boosters" size={SIZE * RATIO_BOOSER_ICON_2} />
      <BoosterIcon3 product="boosters" size={SIZE * RATIO_BOOSER_ICON_2} />
      <BoosterIcon4 product="boosters" size={SIZE * RATIO_BOOSER_ICON} />
    </Root>
  )
}

const Root = styled.div``

const Title = styled.h1`
  position: absolute;
  text-align: center;

  width: 100%;
  top: -120px;
  font-size: 60px;
  font-weight: 700;

  opacity: 0.3;
  background: linear-gradient(
    88deg,
    var(--subscriptionGradientFrom-9) 9.12%,
    var(--subscriptionGradientTo-9) 99.34%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  mask-image: linear-gradient(180deg, #000 0%, transparent 110%);
  -webkit-mask-image: linear-gradient(180deg, #000 0%, transparent 110%);
`

const BuyPremiumIconAlt = styled(BuyPremiumIcon)`
  position: absolute;

  top: -70px;
  left: calc(50% - 50px);
`

const BoosterIcon1 = styled(BuyPremiumIcon)`
  position: absolute;
  rotate: -30deg;
  top: -20px;
  left: 17%;
`

const BoosterIcon2 = styled(BuyPremiumIcon)`
  position: absolute;
  top: -45px;
  left: 27%;
  rotate: -30deg;
`

const BoosterIcon3 = styled(BuyPremiumIcon)`
  position: absolute;
  top: -70px;
  right: 33%;
  rotate: 10deg;
`

const BoosterIcon4 = styled(BuyPremiumIcon)`
  position: absolute;
  top: -20px;
  right: 22%;
  rotate: 15deg;
`
